var $4da03c1ecd9a9c7d$exports = {};
$4da03c1ecd9a9c7d$exports = {
  "alpha": "Alfa",
  "black": "\u010Dierna",
  "blue": "Modr\xE1",
  "blue purple": "modrofialov\xE1",
  "brightness": "Jas",
  "brown": "hned\xE1",
  "brown yellow": "hnedo\u017Elt\xE1",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "az\xFArov\xE1",
  "cyan blue": "az\xFArov\xE1 modr\xE1",
  "dark": "tmav\xE1",
  "gray": "siv\xE1",
  "grayish": "sivast\xE1",
  "green": "Zelen\xE1",
  "green cyan": "zelen\xE1 az\xFArov\xE1",
  "hue": "Odtie\u0148",
  "light": "svetl\xE1",
  "lightness": "Svetlos\u0165",
  "magenta": "purpurov\xE1",
  "magenta pink": "ru\u017Eov\xE1 purpurov\xE1",
  "orange": "oran\u017Eov\xE1",
  "orange yellow": "oran\u017Eovo\u017Elt\xE1",
  "pale": "bled\xE1",
  "pink": "ru\u017Eov\xE1",
  "pink red": "ru\u017Eovo\u010Derven\xE1",
  "purple": "fialov\xE1",
  "purple magenta": "fialov\xE1 purpurov\xE1",
  "red": "\u010Cerven\xE1",
  "red orange": "\u010Dervenooran\u017Eov\xE1",
  "saturation": "S\xFDtos\u0165",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " prieh\u013Eadn\xE1");
  },
  "very dark": "ve\u013Emi tmav\xE1",
  "very light": "ve\u013Emi svetl\xE1",
  "vibrant": "energick\xE1",
  "white": "biela",
  "yellow": "\u017Elt\xE1",
  "yellow green": "\u017Eltozelen\xE1"
};
export { $4da03c1ecd9a9c7d$exports as default };